<template>
  <div>
    <div class="top-breadcrumb">
      <ol class="breadcrumb" style="background-color: white">
        <li class="breadcrumb-item" style="margin-left: 15px">
          <router-link to="" style="color: #8cc63f !important">
            Investors Management
          </router-link>
        </li>
        <li class="breadcrumb-item">
          <router-link
            style="color: #8cc63f !important"
            :to="'/' + authUser.userable_type + '/investors/transactions'"
            >Transactions</router-link
          >
        </li>
      </ol>
    </div>
    <div
      style="display: flex; justify-content: center; margin-top: 60px"
      class="col-12"
    >
      <span
        class="col-1"
        style="
          display: flex;
          align-items: center;
          justify-content: center;
          color: gray;
        "
      >
        <i
          class="fa fa-filter"
          style="font-size: 15px; color: #8cc63f; margin-right: 5px"
        ></i>
        Filter
      </span>
      <span class="col-2">
        <input
          type="text"
          class="form-control"
          placeholder="Transaction ID"
          style="padding: 10px"
          v-model="code"
          @keyup.enter="filter()"
        />
      </span>
      <span class="col-3" style="display: flex">
        <date-range-picker
          ref="picker"
          :locale-data="{
            firstDay: 1,
            format: 'dd-mm-yyyy',
            applyLabel: 'Apply',
            cancelLabel: 'Cancel',
          }"
          :timePicker="false"
          :showDropdowns="true"
          :autoApply="true"
          v-model="dateRange"
          @update="filter()"
          :linkedCalendars="true"
          style="width: 100%; background-color: #fafaf7 !important"
        >
        </date-range-picker>
        <button
          style="font-size: 12px; height: 35px; margin-left: 5px"
          type="button"
          class="btn btn-info"
          @click="clearDateRage()"
        >
          Clear
        </button>
      </span>
      <!-- <span class="col-3">
        <date-range-picker
          ref="picker"
          :locale-data="{
            firstDay: 1,
            format: 'dd-mm-yyyy',
            applyLabel: 'Apply',
            cancelLabel: 'Cancel',
          }"
          :timePicker="false"
          :showDropdowns="true"
          :autoApply="true"
          v-model="dateRange"
          @update="filter()"
          :linkedCalendars="true"
          style="width: 100%"
        >
        </date-range-picker>
      </span>
      <span class="col-1">
        <button
          style="font-size: 14px"
          type="button"
          class="btn btn-info"
          @click="clearDateRage()"
        >
          Clear
        </button>
      </span> -->
      <span class="col-3">
        <multiselect
          v-model="selected_investors"
          :options="investors"
          :multiple="true"
          :close-on-select="false"
          :clear-on-select="false"
          :preserve-search="true"
          placeholder="Select Investors"
          label="code"
          :show-labels="false"
          track-by="id"
          @close="filter()"
        >
          <template slot="selection" slot-scope="{ values, isOpen }"
            ><span
              class="multiselect__single"
              v-if="values.length &amp;&amp; !isOpen"
              >{{ values.length }} investors selected</span
            ></template
          >
        </multiselect>
      </span>
      <span class="col-3">
        <multiselect
          v-model="selected_types"
          :options="transactionTypes"
          :multiple="true"
          :close-on-select="false"
          :clear-on-select="false"
          :preserve-search="true"
          placeholder="Select Types"
          label="name"
          :show-labels="false"
          track-by="id"
          @close="filter()"
        >
          <template slot="selection" slot-scope="{ values, isOpen }"
            ><span
              class="multiselect__single"
              v-if="values.length &amp;&amp; !isOpen"
              >{{ values.length }} types selected</span
            ></template
          >
        </multiselect></span
      >
    </div>
    <div style="display: flex; justify-content: center; margin-top: 50px">
      <div
        style="display: flex; justify-content: center; cursor: pointer"
        @click="redirectToCreateTransaction()"
      >
        <div>
          <i
            class="fa fa-plus-circle"
            style="font-size: 90px; color: #8cc63f; margin-right: 5px"
          ></i>
        </div>
        <div
          style="
            display: flex;
            align-items: center;
            flex-direction: column;
            margin: 0;
            justify-content: center;
            margin-left: 10px;
          "
        >
          <p
            style="
              margin: 0px;
              font-size: 40px;
              margin-bottom: 5px;
              color: #8cc63f;
            "
          >
            ADD
          </p>
          <p style="margin: 0; color: #8cc63f; font-size: 14px">
            new Transaction
          </p>
        </div>
      </div>
    </div>
    <div style="display: flex; justify-content: center; margin-top: 50px">
      <md-card
        class="md-card-stats"
        style="
          background-color: white;
          max-width: 90%;
          border-radius: 15px;
          padding: 40px;
        "
      >
        <spinner v-if="searchingTransactions" />

        <vue-good-table
          v-else
          :columns="transactionColumns"
          :rows="transactions"
          max-height="450px"
          :sort-options="{
            enabled: true,
            initialSortBy: { field: 'code', type: 'asc' },
          }"
        >
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'code'">
              <router-link
                style="color: #00a5e3 !important"
                :to="
                  '/' +
                  authUser.userable_type +
                  '/investors/transaction/' +
                  props.row.code +
                  '/update/' +
                  props.row.id
                "
              >
                {{ props.formattedRow[props.column.field] }}</router-link
              >
            </span>
            <span v-else-if="props.column.label == 'Amount'">
              {{ fixNumberView(props.row.amount) }}
            </span>
            <span v-else-if="props.column.label == 'Final Amount (USD)'">
              {{ getUSDAmount(props.row) }}
            </span>
          </template></vue-good-table
        >
        <!-- <table style="text-align: center">
          <thead>
            <tr>
              <th>#</th>
              <th>Date</th>
              <th>Transaction ID</th>
              <th>Investor ID</th>
              <th>Type</th>
              <th>Amount</th>
              <th>Currency</th>
              <th>Exchange Rate</th>
              <th>Final Amount (USD)</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr
              style="text-align: center"
              v-for="(transaction, key) in transactions"
              :key="key"
            >
              <td>{{ key + 1 }}</td>
              <td>
                {{ moment(transaction.date).format("YYYY-MM-DD") }}
              </td>
              <td>
                {{ transaction.code }}
              </td>
              <td>
                {{ transaction.owner_code }}
              </td>
              <td>
                {{
                  transactionTypes.find((type) => {
                    return type.id == transaction.type;
                  }).name
                }}
              </td>
              <td>
                {{ transaction.amount }}
              </td>
              <td>
                {{ transaction.currency.code }}
              </td>
              <td>
                {{ transaction.exchange_rate }}
              </td>
              <td>
                {{ transaction.amount * transaction.exchange_rate }}
              </td>
              <td>
                <i
                  style="cursor: pointer"
                  @click="redirectToUpdateTransaction(transaction)"
                  class="fa fa-edit"
                ></i>
              </td>
            </tr>
          </tbody>
        </table> -->
      </md-card>
    </div>
  </div>
</template><script>
import sweetAlert from "sweetalert2";
import { mapState } from "vuex";
import moment from "moment";
import TransactionsFilter from "../../filters/TransactionsFilter";
import InvestorsFilter from "../../filters/InvestorsFilter";
import DateRangePicker from "vue2-daterange-picker";
import Spinner from "vue-simple-spinner";
import Multiselect from "vue-multiselect";

export default {
  name: "investorTransactions",
  data() {
    return {
      actionModalType: null,
      transactionTypes: [
        { id: "deposit", name: "Deposit" },
        { id: "withdrawal", name: "Withdrawal" },
      ],
      transactionList: [],
      transactionColumns: [
        {
          label: "Transaction ID",
          field: "code",
        },
        {
          label: "Date",
          field: "date",
        },
        {
          label: "Investor ID",
          field: "owner_code",
        },
        {
          label: "Type",
          field: this.transactionType,
        },
        {
          label: "Amount",
          field: "amount",
        },
        {
          label: "Currency",
          field: "currency.code",
        },
        {
          label: "Exchange Rate	",
          field: "exchange_rate",
        },
        {
          label: "Final Amount (USD)",
          field: this.calculateUSDAmount,
        },
      ],
      type: null,
      transaction_id: null,
      dateRange: {
        startDate: null,
        endDate: null,
      },
      selected_investors: null,
      selected_types: null,
      code: null,
    };
  },
  components: {
    DateRangePicker,
    Spinner,
    Multiselect,
  },
  created: function () {
    var transactionsFilter = TransactionsFilter();
    transactionsFilter.account_types = ["investor_account"];
    this.$store
      .dispatch("searchTransactions", {
        filter: transactionsFilter,
        resultMode: "default",
      })
      .then(() => {
        this.transactionList = this.transactions;
      });
    var investorsFilter = InvestorsFilter();
    this.$store.dispatch("searchInvestors", {
      filter: investorsFilter,
      resultMode: "default",
    });
  },

  computed: {
    ...mapState({
      authUser: (state) => state.userStore.authUser,
      transactions: (state) =>
        state.transactionStore.transactionSearch.transactions,
      investors: (state) => state.investorStore.investorSearch.investors,
      searchingTransactions: (state) =>
        state.transactionStore.transactionSearch.searchingTransactions,
      // createTransactionStatus: (state) =>
      //   state.transactionStore.transactionCreate.createTransactionStatus,
      // updateTransactionStatus: (state) =>
      //   state.transactionStore.transactionUpdate.updateTransactionStatus,
      // deleteTransactionStatus: (state) =>
      //   state.transactionStore.transactionDelete.deleteTransactionStatus,
    }),
    moment() {
      return moment;
    },
  },
  methods: {
    transactionType(transaction) {
      return (
        transaction.type.charAt(0).toUpperCase() + transaction.type.slice(1)
      );
    },
    calculateUSDAmount(transaction) {
      return transaction.amount * transaction.exchange_rate;
    },
    getUSDAmount(transaction) {
      var amount = this.calculateUSDAmount(transaction);
      return this.fixNumberView(amount);
    },
    fixNumberView(value) {
      const numFor = Intl.NumberFormat("en-US", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 4,
      });
      return value < 0
        ? "(" + Math.abs(value).toLocaleString() + ")"
        : numFor.format(value);
    },
    init() {
      this.selectedTransactionId = null;
      this.actionModalType = null;
      this.showTransactionModal = false;
      this.$store.dispatch("searchTransaction").then(() => {
        this.filterTransactions();
      });
    },
    redirectToCreateTransaction() {
      this.$router.push(
        "/" + this.authUser.userable_type + "/investors/transactions/create"
      );
    },
    redirectToUpdateTransaction(transaction) {
      this.$router.push(
        "/" +
          this.authUser.userable_type +
          "/investors/transaction/" +
          transaction.code +
          "/update/" +
          transaction.id
      );
    },
    filter() {
      var transactionsFilter = TransactionsFilter();
      transactionsFilter.code = this.code;
      if (this.selected_investors) {
        this.selected_investors.forEach((investor) => {
          if (!transactionsFilter.account_ids.includes(investor.account_id)) {
            transactionsFilter.account_ids.push(investor.account_id);
          }
        });
      }
      if (this.selected_types) {
        this.selected_types.forEach((type) => {
          if (!transactionsFilter.types.includes(type.id)) {
            transactionsFilter.types.push(type.id);
          }
        });
      }
      // if (this.type) {
      //   transactionsFilter.types = [this.type];
      // }
      if (this.dateRange.startDate != null && this.dateRange.endDate != null) {
        let start_date = moment(this.dateRange.startDate).format("YYYY-MM-DD");
        let end_date = moment(this.dateRange.endDate).format("YYYY-MM-DD");
        let date_range = { startDate: start_date, endDate: end_date };
        transactionsFilter.dateRange = date_range;
      }
      transactionsFilter.account_types = ["investor_account"];
      this.$store.dispatch("searchTransactions", {
        filter: transactionsFilter,
        resultMode: "default",
      });
    },
    clearDateRage() {
      this.dateRange = {
        startDate: null,
        endDate: null,
      };
      this.filter();
    },
    handleSave(transaction) {
      if (this.actionModalType == "createModal") {
        this.createTransaction(transaction);
      } else {
        this.updateTransaction(transaction);
      }
    },
    createTransaction(transaction) {
      this.$store.dispatch("createTransaction", transaction);
    },
    updateTransaction(transaction) {
      this.$store.dispatch("updateTransaction", transaction);
    },
    deleteTransaction(id) {
      sweetAlert({
        title: "Confirmation",
        text: "Are you sure you want to delete this transaction?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.value) {
          this.$store.dispatch("deleteTransaction", id);
        }
      });
    },
    toggleCreateTransactionModal() {
      this.showTransactionModal = !this.showTransactionModal;
      this.showTransactionModal ? (this.actionModalType = "createModal") : null;
    },
    toggleUpdateTransactionModal(id = null) {
      this.showTransactionModal = !this.showTransactionModal;
      if (this.showTransactionModal) {
        this.actionModalType = "updateModal";
        this.selectedTransactionId = id;
      } else {
        this.actionModalType = null;
        this.selectedTransactionId = null;
      }
    },
  },
  watch: {
    // createTransactionStatus() {
    //   if (this.createTransactionStatus == "success") {
    //     sweetAlert({
    //       title: "Success",
    //       text: "Transaction has been created successfully",
    //       icon: "success",
    //       confirmButtonText: "Done",
    //     }).then(() => {
    //       this.init();
    //     });
    //   } else if (this.createTransactionStatus == "failed") {
    //     sweetAlert({
    //       title: "Failed",
    //       text: "Transaction creation has failed",
    //       IntersectionObserver: "error",
    //       confirmButtonText: "Return",
    //     });
    //   }
    // },
    // updateTransactionStatus() {
    //   if (this.updateTransactionStatus == "success") {
    //     sweetAlert({
    //       title: "Success",
    //       text: "Transaction has been updated successfully",
    //       icon: "success",
    //       confirmButtonText: "Done",
    //     }).then(() => {
    //       this.init();
    //     });
    //   } else if (this.updateTransactionStatus == "failed") {
    //     sweetAlert({
    //       title: "Failed",
    //       text: "Transaction update has failed",
    //       IntersectionObserver: "error",
    //       confirmButtonText: "Return",
    //     });
    //   }
    // },
    // deleteTransactionStatus() {
    //   if (this.deleteTransactionStatus == "success") {
    //     sweetAlert({
    //       title: "Success",
    //       text: "Transaction has been deleted successfully",
    //       icon: "success",
    //       confirmButtonText: "Done",
    //     }).then(() => {
    //       this.init();
    //     });
    //   } else if (this.deleteTransactionStatus == "failed") {
    //     sweetAlert({
    //       title: "Failed",
    //       text: "Transaction delete has failed",
    //       IntersectionObserver: "error",
    //       confirmButtonText: "Return",
    //     });
    //   }
    // },
  },
};
</script> 
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.multiselect__option--highlight,
.multiselect__option--highlight:after {
  background: #00a5e3;
}
.multiselect__tags {
  background-color: #fafaf7;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 5px 20px 0 8px;
  font-size: 16px;
}
.multiselect__input,
.multiselect__single {
  background: none;
  font-size: 14px;
  margin: 0;
  margin-top: 5px;
}
.md-ripple {
  padding: 0px !important;
}
.table.vgt-table {
  font-size: 20px;
}
.custom-select {
  background-color: #fafaf7;
}
.form-control {
  background: #fafaf7 !important;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 5px 20px 0 8px !important;
  font-size: 16px;
  border: 1px solid #e8e8e8 !important;
}
.form-control:focus {
  background: #fafaf7 !important; /* Change this to the desired color when the input is focused */
}
.vgt-table.bordered td,
.vgt-table.bordered th {
  border: hidden !important;
}

.vgt-table.bordered td,
.vgt-table.bordered th {
  border: hidden !important;
  background: none;
}

.vgt-inner-wrap {
  box-shadow: none !important;
}
.vgt-left-align {
  text-align: center;
}
.vgt-right-align {
  text-align: center;
}
.vgt-table.bordered td,
.vgt-table.bordered th {
  background: #fff;
}

table.vgt-table thead th {
  position: -webkit-sticky; /* for Safari */
  position: sticky;
  top: 0;
}

/* ===== Scrollbar CSS ===== */
/* Firefox */
* {
  scrollbar-width: auto;
  scrollbar-color: #dbd5dc #ffffff;
}

/* Chrome, Edge, and Safari */
*::-webkit-scrollbar {
  width: 12px;
}

*::-webkit-scrollbar-track {
  background: #ffffff;
}

*::-webkit-scrollbar-thumb {
  background-color: #dbd5dc;
  border-radius: 10px;
  border: 3px solid #ffffff;
}
</style>


// WEBPACK FOOTER //
// resources/js/pages/admin/investorsTransactions.vue